import { AuthClient, WebStorageTokenStore } from '@mrrmlab/auth';
import type { OidcEnv } from '../env';

/**
 * Singleton AuthClient wired to sessionStorage. Returns null when OIDC is
 * not configured (dev mode without Keycloak) — callers should treat this
 * as "no auth, talk to the backend anonymously".
 *
 * sessionStorage (not localStorage) is deliberate: tokens die with the tab,
 * which is a reasonable default for a web app that uses silent re-login
 * via refresh tokens anyway.
 */
export function createAuth(oidc: OidcEnv | null): AuthClient | null {
  if (!oidc) return null;
  return new AuthClient({
    config: {
      issuer: oidc.issuer,
      clientId: oidc.clientId,
      redirectUri: oidc.redirectUri,
      postLogoutRedirectUri: oidc.postLogoutRedirectUri,
      scopes: ['openid', 'profile', 'email', 'offline_access'],
    },
    store: new WebStorageTokenStore(window.sessionStorage),
  });
}
